module.exports = __webpack_public_path__ + "media/images/emblems/Knutwil_LU-3452fa2f358b1b06df7c07fd01902c95.png";